export default function SocialMedia() {
  return (
    <div className="py-16 bg-gradient-to-r from-rose-50 via-peach-50 to-amber-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
          Suivez-nous sur les réseaux sociaux
        </h2>
        <div className="flex justify-center items-center gap-8">
          <a
            href="https://www.facebook.com/profile.php?id=61555539236690"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex flex-col items-center gap-3 transition-transform hover:scale-110"
          >
            <div className="w-20 h-20 flex items-center justify-center bg-white rounded-full shadow-lg group-hover:shadow-xl transition-shadow">
              <i className="ri-facebook-fill text-5xl text-blue-600"></i>
            </div>
            <span className="text-lg font-semibold text-gray-800">Facebook</span>
          </a>
          <a
            href="https://www.instagram.com/peau_perlee/"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex flex-col items-center gap-3 transition-transform hover:scale-110"
          >
            <div className="w-20 h-20 flex items-center justify-center bg-white rounded-full shadow-lg group-hover:shadow-xl transition-shadow">
              <i className="ri-instagram-fill text-5xl text-pink-600"></i>
            </div>
            <span className="text-lg font-semibold text-gray-800">Instagram</span>
          </a>
        </div>
      </div>
    </div>
  );
}
